<template>
  <div :style="cssVariablesBinding" data-x="html" data-x-toggle="html-overflow-hidden">
    <Theme7BaseTheHeader />

    <div v-if="shouldShowComponent" id="msgboxxWidget" />

    <main>
      <slot />
    </main>

    <Theme7BaseTheFooter />
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import IndexGlobal from '~/mixins/index.global';
import LayoutsMixin from '~/mixins/layouts.mixin';
import { useWebsiteStore } from '~/units/website/store';
import AvailableComponentsForTheme7 from '~/components/theme7/AvailableComponentsForTheme7.vue';
import { useAppMode } from '~/composables';

export default defineNuxtComponent({
  name: 'Theme7',

  mixins: [IndexGlobal, LayoutsMixin],

  components: { AvailableComponentsForTheme7 },

  data() {
    return {
      containers: [
        {
          name: 'BLOGS_VIEW',
          classes: 'blog-wrap5',
        },
        {
          name: 'BLOG_DETAIL_VIEW',
          classes: 'blog-wrap6',
        },
      ],
    };
  },

  head(context) {
    const appMode = useAppMode();

    if (appMode.server && context.ssrContext) {
      const websiteStore = useWebsiteStore();
      const isCopeAndCo = websiteStore.companyKey === 'copeandco';
      const tagScripts = (() => {
        if (process.env.APP_STAGE === 'production') {
          return [
            ...websiteStore.googleTagsScripts,
            {
              key: 'company-analytics',
              type: 'text/javascript',
              src: `/trackers/${websiteStore.company?.company_key}.js`,
              async: false,
            },
          ];
        }
        return [];
      })();

      return {
        link: [
          {
            rel: 'stylesheet',
            href: `/theme7/css/theme/main.css`,
            type: 'text/css',
          },
          {
            rel: 'stylesheet',
            href: `/theme7/css/theme/vendors.css`,
            type: 'text/css',
          },
          {
            rel: 'stylesheet',
            href: `/theme7/css/${websiteStore.company?.company_key}/index.css`,
            type: 'text/css',
            fetchPriority: 'low',
          },

          !isCopeAndCo
            ? {
                rel: 'stylesheet',
                href: 'https://use.typekit.net/chv5ecj.css',
                type: 'text/css',
              }
            : null,

          isCopeAndCo
            ? {
                rel: 'stylesheet',
                href: 'https://cdn.msgboxx.io/static/css/bundle.min.css',
                type: 'text/css',
              }
            : null,
        ],
        script: [
          ...tagScripts,
          isCopeAndCo
            ? {
                src: 'https://cdn.msgboxx.io/static/js/bundle.min.js',
                async: true,
                onload: "window.msgboxxClient='COPE';",
                body: true,
              }
            : null,
          isCopeAndCo
            ? {
                src: `https://assets.calendly.com/assets/external/widget.js`,
                type: 'text/javascript',
                async: true,
              }
            : null,
          {
            src: `/theme7/js/theme/vendors.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme7/js/theme/main.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/trackers/${websiteStore.company?.company_key}.js`,
            type: 'text/javascript',
            async: false,
          },
        ],
      };
    }
  },

  computed: {
    ...mapState(useWebsiteStore, ['currentPage', 'company']),

    cssVariablesBinding() {
      return {
        ...this.cssVariables,
        '--primary-color': 'var(--c-primary)',
        '--akya-text-color': 'var(--c-text-primary)',
        '--akya-background-color': 'var(--c-section_primary)',
        '--akya-confirm-button-text-color': 'var(--c-text-secondary)',
        '--akya-confirm-button-background-color': 'var(--c-primary)',
      };
    },

    isCopeAndCo() {
      return useWebsiteStore().company?.company_key === 'copeandco';
    },

    isKinetic() {
      /* return useWebsiteStore().companyKey === 'kineticestateagents'; */
      return false;
    },

    isHarrisAndWood() {
      /* return useWebsiteStore().companyKey === 'harrisandwood'; */
      return false;
    },

    shouldShowComponent() {
      const currentPath = this.$route.path;
      const isInHeadsUpAlerts = currentPath.startsWith('/heads-up-alerts');
      return this.isCopeAndCo && !isInHeadsUpAlerts;
    },
  },
});
</script>
